import React, { useContext, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../Contexts/AuthContext/AuthProvider';

function getCookie(name) {
    const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return cookieValue ? cookieValue.pop() : '';
}

const UserMobilePrivateRoute = ({ children }) => {

    const { authUser, authId, loading } = useContext(AuthContext);




    const location = useLocation();
    const [token, setToken] = useState(getCookie("WFL_token"));
    // if (loading) {
    //     return <></>;
    // }
    if (!token) {
        return <Navigate to='/' sate={{ from: location }} replace ></Navigate>

    } else {
        if (token) {
            return children;
        } else {
            <Navigate to='*' sate={{ from: location }} replace></Navigate>
        }
    }



}

export default UserMobilePrivateRoute;